import { AsyncActionsScenario } from "onearm";

export async function presentation(scope, ctx, spinData) {
    const { hud } = ctx;
    const { result, quickStop } = spinData;

    hud.setPresentationState();

    const actions = ctx.makePresentation(result, { quickStop });
    const scenario = new AsyncActionsScenario({ actions });

    scope.on(hud.onStop, () => scenario.skipAllIfPossible());

    scenario.start();

    await new Promise((resolve) => {
        scenario.onComplete.connect(resolve);
    });
}
